import {
  APP_3in1,
  APP_M1,
  APP_SRC,
  APP_URL_INDENTIFIER,
  WEB_VIEW_MODE,
  WEB_VIEW_MODE_ON,
} from "../constants/sso.constants";
import { getCookie, getParams, isBrowser } from "./common-utils";

export const isOpenInApp = (): boolean => {
  return (
    isBrowser() &&
    (window.location.href.includes(APP_URL_INDENTIFIER) ||
      getParams(APP_SRC) === APP_3in1 ||
      getParams(APP_SRC) === APP_M1 ||
      getCookie(WEB_VIEW_MODE) === WEB_VIEW_MODE_ON)
  );
};
export const stringToBoolean = (value: string | boolean | undefined): boolean => {
  if (typeof value === "boolean") {
    return value;
  }
  if (value === null || value === undefined) {
    return false;
  }
  switch (String(value)?.toLowerCase().trim()) {
    case "true":
    case "yes":
    case "1":
      return true;
    case "false":
    case "no":
    case "0":
    case null:
      return false;
    default:
      return Boolean(value);
  }
};
